// @flow

import React from 'react'
import Header from '../partials/Header.jsx'
import Footer from '../partials/Footer.jsx'
import SupportList from '../partials/SupportList.jsx'
import imgFirstAsia from '../../images/public/FirstAsiaConsultants.png'
import imgKarirpad from '../../images/public/Karirpad.png'
import imgUrbanHire from '../../images/public/Urbanhire.png'
import imgIndotrainee from '../../images/public/Indotrainee.png'
import CallToActRegister from '../partials/CallToActRegister.jsx'

type State = {
	jobs: Array<Object>
};

class PartnersPage extends React.Component<State> {
	componentDidMount() {
		window.scrollTo(0, 0)
	}

  render() {

    return (
			<main>
	      <section className="homepage-feature">
	        <Header isNavbarFixed={true} />
	        <div className="homepage-feature--image partnerspage">
	          <div className="container">
	            <div className="jumbotron">
	              <div className="row">
	                <div className="col-md-8 col-sm-12 col-xs-12">
										<div className="flex vertical-item--between">
	                    <div className="flex-1">
												<h2 className="section-heading m-t-0">Partnership and Integrations</h2>
			                  <p>We partner well. It’s part of our attitude and way of life. Companies and candidates want powerful and fast experiences that don’t add stress but instead take off a load. By working with partners we achieve this. If you have an idea for a partnership we’d love to hear from you.</p>
	                    </div>
	                  </div>
	                </div>
	              </div>
	            </div>
	          </div>
	        </div>
	      </section>
	      <section>
	        <div className="container partnerspage-content">
						<div className="row m-b-40">
							<div className="col-sm-12">
								<h2 className="heading1 m-b-8">Assessment providers</h2>
								<img src={imgFirstAsia} alt="FirstAsia" />
								<p className="heading5 normal">We partner with some of the most progressive assessment providers, focussed on candidate experience and deep validation of their methodologies. Contact us for more information.</p>
							</div>
	          </div>
						<div className="row m-b-40">
							<div className="col-sm-12">
								<h2 className="heading1 m-b-8">API</h2>
								<div className="flex-container">
									<img src={imgUrbanHire} alt="UrbanHire" className="m-r-24" />
									<img src={imgKarirpad} alt="Karirpad.com" />
								</div>
								<p className="heading5 normal">Our API is versatile. Having everything in a single dashboard is bliss, and we make that happen for ATS and HRIS providers. But we also help make job
								videos, onboarding, training and employee engagement more rich and rewarding with video. Everyone can have the power of video in their
								platform without making their lives complicated. Everyone’s a winner. </p>
							</div>
	          </div>
						<div className="row m-b-40">
							<div className="col-sm-12">
								<h2 className="heading1 m-b-8">Satellite Labs</h2>
								<div className="flex-container">
									<img src={imgIndotrainee} alt="Indotrainee" />
								</div>
								<p className="heading5 normal">We love to innovative integrations with partners and realise that building a software project team might not be easily done for some of them. We help them out by facilitating freelancers for them. Contact us for more information and let’s innovate together.</p>
							</div>
	          </div>
						<div className="row m-b-40">
							<div className="col-sm-12">
								<h2 className="heading1 m-b-8">Refferal Program</h2>
								<p className="heading5 normal">Many times it’s easier for clients to learn about us via partners. Which is great for our clients, us and also our partners as part of our referral program. Contact us for more information.</p>
							</div>
	          </div>
						<div className="row m-b-40">
							<div className="col-sm-12">
								<h2 className="heading1 m-b-8">Partners</h2>
								<p className="heading5 normal">As we mentioned above, we partner well. It’s part of our attitude and way of life. If you have an idea that doesn’t fit into the above categories, but you think we’ll be interested, please contact us.</p>
							</div>
	          </div>
					</div>
	      </section>
				<div className="container">
					<div className="row">
						<div className="col-sm-12">
							<div className="section-divider"></div>
						</div>
					</div>
				</div>
	      <SupportList />
				<CallToActRegister />
				<Footer />
			</main>
		)
  }
}

export default PartnersPage
